import * as React from 'react';
import ButtonData from "./ModuleData";
import { EditViewProps } from "../interfaces";

export interface ButtonInPlaceEditViewProps extends EditViewProps<ButtonData>, React.Props<ButtonInPlaceEditView> {
}

export default class ButtonInPlaceEditView extends React.Component<ButtonInPlaceEditViewProps, {}> {

    render() {
        return (
         <div />
        );
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/button/InPlaceEditView.tsx
 **/